var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[_c('BoxError',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h2',[_vm._v("ページが見つかりません")])]},proxy:true},{key:"button",fn:function(){return [_c('router-link',{staticClass:"btn",attrs:{"to":"/"}},[_vm._v("トップページに戻る")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }